const PHOTOS = [
  { src: '/images/photo-0.png', caption: 'Manali, Himachal Pradesh' },
  { src: '/images/photo-1.png', caption: 'Snow days, Manali' },
  { src: '/images/photo-2.jpg', caption: 'Sunrise at the summit' },
  { src: '/images/photo-3.jpg', caption: 'Varkala Beach, Kerala' },
  { src: '/images/photo-4.jpg', caption: 'Snow Temple, Manali' },
  { src: '/images/photo-5.jpg', caption: 'Kasol, Himachal Pradesh' },
  { src: '/images/photo-6.jpg', caption: 'Design Crew Meetup' },
  { src: '/images/photo-7.jpg', caption: 'GenAI Buildathon, 100xEngineers' },
  { src: '/images/photo-8.jpg', caption: '10k Designers Kit' },
];

export default PHOTOS;
